import React from 'react';
import { Container, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const Attribution = () => {
  const { t } = useTranslation();

  const translationAttribution = () => {
    return (
      <Typography variant="body2" color="textSecondary" align="center">
        {t('attribution.translatedBy')}{' '}
        <Link href={t('attribution.translatorLink')}>
          {t('attribution.translatorName')}
        </Link>
      </Typography>
    );
  };

  return (
    <Container>
      <Typography
        margin={4}
        variant="body2"
        color="textSecondary"
        align="center"
      >
        {t('attribution.createdBy')}{' '}
        <Link
          href="https://github.com/jhaals/yopass"
          target="_blank"
          rel="noopener noreferrer"
        >
          Johan Haals
        </Link>
      </Typography>

      <Typography
        margin={0}
        variant="body2"
        color="textSecondary"
        align="center"
      >
        Modified & managed by <strong>Linux Platform & Containers Team</strong>
      </Typography>

      {t('attribution.translatorName') && translationAttribution()}
    </Container>
  );
};
